import React from 'react';
import './About.css';
import { Link } from 'react-router-dom';
import {
  FaBullseye,
  FaEye,
  FaHandshake,
  FaLightbulb
} from "react-icons/fa";

const About = () => {
  return (
    <section id="about" className="about section section-bg dark-background">
      <div className="container position-relative">
        <div className="row gy-5">

          {/* Left Content */}
          <div className="content col-xl-5 d-flex flex-column">
            <h3>ABCD International Family</h3>
            <p>
              A global training and coaching organization dedicated to reducing failure 
              and bringing success and happiness into people’s lives worldwide. 
              We specialize in corporate and business training, empowering individuals 
              and organizations to grow in every aspect of life and business.
            </p>
            <div className="d-flex mt-4">
              <Link to="/about-details" className="about-btn">About Us</Link>
            </div>
          </div>

          {/* Right Content (icon boxes) */}
          <div className="col-xl-7">
            <div className="row gy-4">

              <div className="col-md-6 icon-box position-relative">
                <FaEye className="info-icon" />
                <h4><span className="stretched-link fake-link">Vision</span></h4>
                <p>To reduce failure and bring success and happiness in people's life worldwide.</p>
              </div>

              <div className="col-md-6 icon-box position-relative">
                <FaBullseye className="info-icon" />
                <h4><span className="stretched-link fake-link">Mission</span></h4>
                <p>Help people grow in every aspect of life and business worldwide.</p>
              </div>

              <div className="col-md-6 icon-box position-relative">
                <FaHandshake className="info-icon" />
                <h4><span className="stretched-link fake-link">Core Values</span></h4>
                <p>Continuous Upgradation, Respect, Helpful, Socially Responsible, Trust</p>
              </div>

              <div className="col-md-6 icon-box position-relative">
                <FaLightbulb className="info-icon" />
                <h4><span className="stretched-link fake-link">Core Purpose</span></h4>
                <p>To provide the best valuable solutions, services and products worldwide.</p>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default About;
